var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-2",
    d: "M4 0.5H16C17.3789 0.5 18.5 1.62114 18.5 3V23C18.5 23.2739 18.2739 23.5 18 23.5H2C1.72614 23.5 1.5 23.2739 1.5 23V3C1.5 1.62114 2.62114 0.5 4 0.5Z",
    fill: "#EAEEF2",
    stroke: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11.75 5.75H5.25C4.835 5.75 4.5 5.415 4.5 5C4.5 4.585 4.835 4.25 5.25 4.25H11.75C12.165 4.25 12.5 4.585 12.5 5C12.5 5.415 12.165 5.75 11.75 5.75Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M14.75 9H5.25C4.835 9 4.5 8.665 4.5 8.25C4.5 7.835 4.835 7.5 5.25 7.5H14.75C15.165 7.5 15.5 7.835 15.5 8.25C15.5 8.665 15.165 9 14.75 9Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarTop);
export default __webpack_public_path__ + "static/media/bar-top.44597c62dcb4b712422cb8bc9ee89fcc.svg";
export { ForwardRef as ReactComponent };